<div style="text-align: center;">
    <button style="position:relative; top:50%; transform:translateY(-50%);" class="btn btn-primary" data-ng-click="ui.redirect()">{{'dashboard.widgets.linkWidget.buttonText' | i18n}} {{dashboard.model.title}}</button>
</div>
